export const NULL_ADDRESS = '0x0000000000000000000000000000000000000000'
export const NULL_BYTES32 = '0x0000000000000000000000000000000000000000000000000000000000000000'

export const NULL_ECDSA_SIGNATURE = {
  r: '',
  s: '',
  v: 0
}
